angular.module('settings')
    .factory('TenantProfile', function ($resource) {
        return $resource('/crm/api/tenant-profile', {}, {
            get: {method: 'GET'},
            update: {method: 'PUT'},
            deleteLogo: {method: 'DELETE', url: '/crm/api/tenant-profile/logo'},
            deleteSystemLogo: {method: 'DELETE', url: '/crm/api/tenant-profile/system-logo'}
        })
    })
    .component('tenantProfileSettingsComponent', {
        templateUrl: 'app/settings/tenant-profile.html',
        controller: function ($timeout, $cookies, toastr, TenantProfile, FileUploader, FileUploaderCustom) {
            this.$onInit = () => {
                this.renderTime = new Date().getTime()
                let imgFilter = {
                    name: 'Plik nie jest obrazem',
                    fn: item => {
                        let type = (item.type || '').toLowerCase()
                        let name = (item.name || '').toLowerCase()
                        return type.indexOf('image/') === 0 || /\.(png|jpe?g|gif|webp|svg)$/.test(name)
                    }
                };

                this.uploader = FileUploaderCustom.create('/crm/api/tenant-profile/logo', () => ({}), () => {
                    this.$onInit()
                }, {multiple: false, autoUpload: true, removeAfterUpload: true, filters: [imgFilter]})

                this.systemUploader = FileUploaderCustom.create('/crm/api/tenant-profile/system-logo', () => ({}), () => {
                    this.$onInit()
                }, {multiple: false, autoUpload: true, removeAfterUpload: true, filters: [imgFilter]})

                return this.reload()
            }

            this.reload = () => {
                this.renderTime = new Date().getTime()
                return TenantProfile.get().$promise.then(result => this.item = result)
            }

            this.save = () => {
                return TenantProfile.update(this.item).$promise
                    .then(result => {
                        this.item = result
                        toastr.success("Zapisano")
                    })
            }

            this.deleteLogo = () => {
                return TenantProfile.deleteLogo().$promise.then(result => {
                    this.item = result
                    this.renderTime = new Date().getTime()
                })
            }
            this.deleteSystemLogo = () => {
                return TenantProfile.deleteSystemLogo().$promise.then(result => {
                    this.item = result
                    this.renderTime = new Date().getTime()
                })
            }
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('tenantProfileSettings', {
            parent: 'app',
            url: '/settings/tenant-profile',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': 'tenantProfileSettingsComponent'
            }
        })
    })
